import { useState } from "react";
import Tabs from "../tabs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Box, Grid, useMediaQuery } from "@mui/material";
import CustomButton from "../../../../components/buttons/customButton";
import SnackbarMessage from "../../../../components/snackBar/snackBar";

function SlotTimingCreation() {
    const [slotTimings, setSlotTimings] = useState([
        { id: 1, label: "From Time", value: dayjs() },
        { id: 2, label: "To Time", value: dayjs().add(1, "hour") }
    ]);

    const [errors, setErrors] = useState({
        fromTime: "",
        toTime: "",
    });


    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const isMobile = useMediaQuery("(max-width:600px)");

    const handleTimeChange = (id, newValue) => {
        setSlotTimings((prev) =>
            prev.map((slot) =>
                slot.id === id ? { ...slot, value: newValue } : slot
            )
        );

        setErrors(prev => ({ ...prev, fromTime: "", toTime: "" }))
    };

    const handleSubmit = () => {
        const fromTime = slotTimings.find(t => t.id === 1)?.value;
        const toTime = slotTimings.find(t => t.id === 2)?.value;

        let newErrors = {
            fromTime: "",
            toTime: "",
        };

        if (!fromTime) {
            newErrors.fromTime = "From Time is required";
        }

        if (!toTime) {
            newErrors.toTime = "To Time is required";
        }

        if (fromTime && toTime && dayjs(fromTime).isAfter(dayjs(toTime))) {
            newErrors.toTime = "To Time must be greater than From Time";
        }

        setErrors(newErrors);

        // If any error exists, stop submit
        if (newErrors.fromTime || newErrors.toTime) {
            setSnackbar({
                open: true,
                message: "Please fix the validation errors",
                severity: "error",
            });
            return;
        }

        // ✅ Success case
        setSnackbar({
            open: true,
            message: "Slot created successfully",
            severity: "success",
        });
    };

    return (
        <Box>
            <Tabs />

            <Grid container spacing={2} mt={2} justifyContent={isMobile ? "center" : "start"}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {slotTimings.map((slot) => (
                        <Grid item key={slot.id}>
                            <TimePicker
                                label={slot.label}
                                value={slot.value}
                                minTime={
                                    slot.id === 2
                                        ? slotTimings.find(t => t.id === 1)?.value?.add(1, "hour")
                                        : undefined
                                }
                                onChange={(newValue) =>
                                    handleTimeChange(slot.id, newValue)
                                }
                                slotProps={{
                                    textField: {
                                        size: 'small', // Set the size to 'small'
                                        error:
                                            (slot.id === 1 && Boolean(errors.fromTime)) ||
                                            (slot.id === 2 && Boolean(errors.toTime)),
                                    },
                                    openPickerButton: {
                                        sx: {
                                            color: "green",
                                            "& svg": {
                                                fontSize: "32px", // 👈 icon size
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>
                    ))}
                </LocalizationProvider>

                <CustomButton
                    status={false}
                    onClick={handleSubmit}
                    label="Create Slot"
                    loadingLabel="Submitting.."
                />
            </Grid>



            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Box>
    );
}
export default SlotTimingCreation;